<div
  class="vtab-action-bar-content"
  [class.has-only-buttons]="hasOnlyButtons"
  [class.has-more-than-two-buttons]="buttonCount > 2">
  <ng-content></ng-content>
</div>
